import BoardEntity from '../entities/Board';

export type State = BoardEntity[];

const initialState: State = [];

const Board = (state: State = initialState, action: any) => {
  switch (action.type) {
    case 'SUCCESS_READ_BOARDS_BY_GROUP':
      return [...state, ...action.boards].filter(
        (board, index, self) => self.map(w => w.id).indexOf(board.id) === index
      );

    case 'SUCCESS_READ_BOARDS_DIFF':
      const boardsChanged = state.map(board =>
        action.boards.map((m: BoardEntity) => m.id).includes(board.id)
          ? action.boards.find((m: BoardEntity) => m.id === board.id)
          : board
      );

      const boardsToAdd = action.boards.filter(
        (board: BoardEntity) => !state.map(m => m.id).includes(board.id)
      );

      return [...boardsChanged, ...boardsToAdd];

    case 'SUCCESS_CREATE_BOARD':
      return [...state, action.board].filter(
        (board, index, self) => self.map(w => w.id).indexOf(board.id) === index
      );

    case 'SUCCESS_UPDATE_BOARD':
      return state.map(board => {
        return board.id === action.board.id ? action.board : board;
      });

    case 'SUCCESS_DESTROY_BOARD':
      return state.filter(board => board.id !== action.board.id);
  }

  return state;
};

export default Board;



// WEBPACK FOOTER //
// ./src/reducers/Board.ts